module.exports = __webpack_public_path__ + "static/media/33.5da5c8fa.jpg";